module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Maps"
    }
  }, [_c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("Map 1: Fighter Command during the Battle of Britain, 1940. Diane Bricknell")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "fig-img"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_3.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("Map 2: 11 Group during the Battle of Britain, 1940. Diane Bricknell")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68decf01","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Maps.vue
// module id = 72
// module chunks = 0